// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Download
export default Download = class Download extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  url() {
    let url = this.urlRoot(`/api/private/`)
    url += `path/${this.options.path}/item/${this.options.step}/download/`
    if (this.id) {
      url += `${this.id}/`
    }
    return url
  }
}
